// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-actions-panel .panel-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.action-feedback {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 12px;
  line-height: 1.4;
  animation: fadeIn 0.2s ease-out;
}

.action-feedback.action-accept {
  background: rgba(0, 168, 85, 0.12);
  border-color: rgba(0, 168, 85, 0.35);
  color: #baf2ce;
}

.action-feedback.action-reject {
  background: rgba(255, 75, 75, 0.12);
  border-color: rgba(255, 75, 75, 0.35);
  color: #ff9999;
}

.action-feedback.action-edit {
  background: rgba(255, 165, 0, 0.12);
  border-color: rgba(255, 165, 0, 0.35);
  color: #ffd699;
}

.action-feedback strong {
  color: #ffffff;
}

/* Actions Sections */
.actions-section {
  padding: 12px;
  background: rgba(40, 40, 40, 0.6);
  border-radius: 6px;
  border-left: 3px solid #4ecdc4;
  transition: all 0.2s ease;
}

.actions-section .section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888888;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Primary Action Buttons */
.primary-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.action-btn:hover:not(:disabled) {
  background: rgba(60, 60, 60, 0.9);
  border-color: #4a4a4a;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.action-btn:active:not(:disabled) {
  transform: translateY(0);
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-btn.active {
  animation: btnPulse 0.4s ease-out;
}

@keyframes btnPulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.98);
  }
}

.btn-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.btn-text {
  flex: 1 1;
}

/* Specific Button Styles */
.action-btn.accept {
  border-left: 3px solid #00a855;
}

.action-btn.accept:hover:not(:disabled) {
  border-left-color: #00a855;
}

.action-btn.reject {
  border-left: 3px solid #ff4b4b;
}

.action-btn.reject:hover:not(:disabled) {
  border-left-color: #ff4b4b;
}

.action-btn.edit {
  border-left: 3px solid #ffa500;
}

.action-btn.edit:hover:not(:disabled) {
  border-left-color: #ffa500;
}

.action-btn.explain {
  border-left: 3px solid #9b59b6;
}

.action-btn.explain:hover:not(:disabled) {
  border-left-color: #9b59b6;
}

/* Secondary Actions */
.secondary-actions {
  border-left-color: #888888;
}

.action-btn.comparison,
.action-btn.export {
  border-left: 3px solid #888888;
}

.action-btn.comparison:hover:not(:disabled),
.action-btn.export:hover:not(:disabled) {
  border-left-color: #aaaaaa;
}

/* Feedback Section */
.feedback-section {
  border-left-color: #9b59b6;
}

.toggle-feedback-btn {
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  color: #ffffff;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
}

.toggle-feedback-btn:hover {
  background: #3a3a3a;
}

.feedback-form {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: expandSection 0.2s ease-out;
}

.feedback-input {
  width: 100%;
  padding: 10px;
  background: rgba(30, 30, 30, 0.8);
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  color: #ffffff;
  font-size: 12px;
  font-family: inherit;
  resize: vertical;
  min-height: 60px;
}

.feedback-input:focus {
  outline: none;
  border-color: #0066cc;
  background: rgba(35, 35, 35, 0.9);
}

.feedback-input::placeholder {
  color: #666666;
}

.submit-feedback-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 4px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.submit-feedback-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

.submit-feedback-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Action History */
.action-history {
  border-left-color: #4ecdc4;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.history-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: rgba(30, 30, 30, 0.6);
  border-radius: 4px;
  font-size: 11px;
  color: #aaaaaa;
}

.history-icon {
  font-size: 14px;
  color: #4ecdc4;
}

.history-text {
  flex: 1 1;
  text-transform: capitalize;
  color: #ffffff;
}

.history-time {
  font-size: 10px;
  color: #666666;
}

/* Personalized Section */
.personalized-section {
  border-left-color: #f39c12;
}

.personalized-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.recommendation-item {
  display: flex;
  gap: 10px;
  padding: 10px;
  background: rgba(30, 30, 30, 0.6);
  border-radius: 4px;
  border-left: 2px solid #f39c12;
}

.rec-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.rec-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rec-text strong {
  font-size: 12px;
  color: #ffffff;
}

.rec-text small {
  font-size: 11px;
  color: #aaaaaa;
  line-height: 1.4;
}

.recommendation-placeholder {
  padding: 10px;
  background: rgba(30, 30, 30, 0.4);
  border-radius: 4px;
  border: 1px dashed #3a3a3a;
  text-align: center;
}

/* Workflow Integration */
.workflow-integration {
  border-left-color: #3498db;
}

.workflow-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.workflow-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #aaaaaa;
  cursor: pointer;
}

.workflow-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #3498db;
}

.workflow-checkbox:hover {
  color: #ffffff;
}

/* Help Section */
.help-section {
  border-left-color: #95a5a6;
  padding: 8px;
}

.help-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background: rgba(30, 30, 30, 0.6);
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  color: #aaaaaa;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.help-btn:hover {
  background: rgba(40, 40, 40, 0.8);
  color: #ffffff;
  border-color: #4a4a4a;
}

/* Modal Styles */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: #2a2a2a;
  border: 1px solid #4a4a4a;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #3a3a3a;
}

.modal-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.modal-body label {
  display: block;
  color: #cccccc;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}

.modal-textarea {
  width: 100%;
  background: rgba(40, 40, 40, 0.8);
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  color: #ffffff;
  font-size: 13px;
  font-family: inherit;
  padding: 12px;
  resize: vertical;
  transition: border-color 0.2s ease;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #3a3a3a;
}

.close-btn {
  background: none;
  border: none;
  color: #888888;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  line-height: 1;
}

.close-btn:hover {
  color: #ffffff;
}

.cancel-btn,
.confirm-accept-btn,
.confirm-reject-btn,
.confirm-edit-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.cancel-btn {
  background: rgba(60, 60, 60, 0.8);
  color: #ffffff;
  border: 1px solid #4a4a4a;
}

.confirm-accept-btn {
  background: #00a855;
  color: #ffffff;
}

.confirm-reject-btn {
  background: #ff4b4b;
  color: #ffffff;
}

.confirm-edit-btn {
  background: #ffa500;
  color: #ffffff;
}

.cancel-btn:hover,
.confirm-accept-btn:hover,
.confirm-reject-btn:hover,
.confirm-edit-btn:hover {
  filter: brightness(1.2);
}


/* Rejection Modal Specific Styles */

.rejection-textarea:focus {
  outline: none;
  border-color: #ff6b6b;
  background: rgba(40, 40, 40, 0.95);
}

.rejection-textarea::placeholder {
  color: #666666;
}

/* Edit Modal Specific Styles */

.edit-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.edit-field label {
  color: #cccccc;
  font-size: 13px;
  font-weight: 500;
}

.birads-select {
  background: rgba(40, 40, 40, 0.8);
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  color: #ffffff;
  font-size: 13px;
  font-family: inherit;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.birads-select:focus {
  outline: none;
  border-color: #4ecdc4;
  background: rgba(40, 40, 40, 0.95);
}

.birads-select option {
  background: #2a2a2a;
  color: #ffffff;
}

.findings-textarea {
  width: 100%;
  background: rgba(40, 40, 40, 0.8);
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  color: #ffffff;
  font-size: 13px;
  font-family: inherit;
  padding: 12px;
  resize: vertical;
  min-height: 120px;
  transition: border-color 0.2s ease;
  line-height: 1.5;
}

.findings-textarea:focus {
  outline: none;
  border-color: #4ecdc4;
  background: rgba(40, 40, 40, 0.95);
}

.findings-textarea::placeholder {
  color: #666666;
}

/* Explanation Container Styles */
.explanation-container {
  padding: 16px;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid #3a3a3a;
  border-left: 3px solid #9b59b6;
  border-radius: 6px;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.explanation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #3a3a3a;
}

.explanation-header h5 {
  margin: 0;
  color: #9b59b6;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.close-explanation-btn {
  background: none;
  border: none;
  color: #888888;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  line-height: 1;
}

.close-explanation-btn:hover {
  color: #ffffff;
}

.explanation-content {
  color: #cccccc;
  font-size: 13px;
  line-height: 1.6;
}

.explanation-content p {
  margin: 0 0 12px 0;
}

.explanation-content p:last-child {
  margin-bottom: 0;
}

.explanation-note {
  background: rgba(155, 89, 182, 0.1);
  border-left: 2px solid #9b59b6;
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #bbbbbb;
}

.explanation-note strong {
  color: #9b59b6;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/UserActionsPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,uBAAuB;AACzB;;;AAGA,oCAAoC;;AAEpC;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".user-actions-panel .panel-content {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.action-feedback {\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 12px;\n  line-height: 1.4;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.action-feedback.action-accept {\n  background: rgba(0, 168, 85, 0.12);\n  border-color: rgba(0, 168, 85, 0.35);\n  color: #baf2ce;\n}\n\n.action-feedback.action-reject {\n  background: rgba(255, 75, 75, 0.12);\n  border-color: rgba(255, 75, 75, 0.35);\n  color: #ff9999;\n}\n\n.action-feedback.action-edit {\n  background: rgba(255, 165, 0, 0.12);\n  border-color: rgba(255, 165, 0, 0.35);\n  color: #ffd699;\n}\n\n.action-feedback strong {\n  color: #ffffff;\n}\n\n/* Actions Sections */\n.actions-section {\n  padding: 12px;\n  background: rgba(40, 40, 40, 0.6);\n  border-radius: 6px;\n  border-left: 3px solid #4ecdc4;\n  transition: all 0.2s ease;\n}\n\n.actions-section .section-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888888;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Primary Action Buttons */\n.primary-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  padding: 12px 16px;\n  background: rgba(50, 50, 50, 0.8);\n  border: 1px solid #3a3a3a;\n  border-radius: 6px;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.action-btn:hover:not(:disabled) {\n  background: rgba(60, 60, 60, 0.9);\n  border-color: #4a4a4a;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.action-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.action-btn.active {\n  animation: btnPulse 0.4s ease-out;\n}\n\n@keyframes btnPulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(0.98);\n  }\n}\n\n.btn-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.btn-text {\n  flex: 1;\n}\n\n/* Specific Button Styles */\n.action-btn.accept {\n  border-left: 3px solid #00a855;\n}\n\n.action-btn.accept:hover:not(:disabled) {\n  border-left-color: #00a855;\n}\n\n.action-btn.reject {\n  border-left: 3px solid #ff4b4b;\n}\n\n.action-btn.reject:hover:not(:disabled) {\n  border-left-color: #ff4b4b;\n}\n\n.action-btn.edit {\n  border-left: 3px solid #ffa500;\n}\n\n.action-btn.edit:hover:not(:disabled) {\n  border-left-color: #ffa500;\n}\n\n.action-btn.explain {\n  border-left: 3px solid #9b59b6;\n}\n\n.action-btn.explain:hover:not(:disabled) {\n  border-left-color: #9b59b6;\n}\n\n/* Secondary Actions */\n.secondary-actions {\n  border-left-color: #888888;\n}\n\n.action-btn.comparison,\n.action-btn.export {\n  border-left: 3px solid #888888;\n}\n\n.action-btn.comparison:hover:not(:disabled),\n.action-btn.export:hover:not(:disabled) {\n  border-left-color: #aaaaaa;\n}\n\n/* Feedback Section */\n.feedback-section {\n  border-left-color: #9b59b6;\n}\n\n.toggle-feedback-btn {\n  background: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  color: #ffffff;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: all 0.2s ease;\n}\n\n.toggle-feedback-btn:hover {\n  background: #3a3a3a;\n}\n\n.feedback-form {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  animation: expandSection 0.2s ease-out;\n}\n\n.feedback-input {\n  width: 100%;\n  padding: 10px;\n  background: rgba(30, 30, 30, 0.8);\n  border: 1px solid #3a3a3a;\n  border-radius: 4px;\n  color: #ffffff;\n  font-size: 12px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 60px;\n}\n\n.feedback-input:focus {\n  outline: none;\n  border-color: #0066cc;\n  background: rgba(35, 35, 35, 0.9);\n}\n\n.feedback-input::placeholder {\n  color: #666666;\n}\n\n.submit-feedback-btn {\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border: none;\n  border-radius: 4px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.submit-feedback-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);\n}\n\n.submit-feedback-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Action History */\n.action-history {\n  border-left-color: #4ecdc4;\n}\n\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.history-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: rgba(30, 30, 30, 0.6);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #aaaaaa;\n}\n\n.history-icon {\n  font-size: 14px;\n  color: #4ecdc4;\n}\n\n.history-text {\n  flex: 1;\n  text-transform: capitalize;\n  color: #ffffff;\n}\n\n.history-time {\n  font-size: 10px;\n  color: #666666;\n}\n\n/* Personalized Section */\n.personalized-section {\n  border-left-color: #f39c12;\n}\n\n.personalized-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.recommendation-item {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n  background: rgba(30, 30, 30, 0.6);\n  border-radius: 4px;\n  border-left: 2px solid #f39c12;\n}\n\n.rec-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.rec-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rec-text strong {\n  font-size: 12px;\n  color: #ffffff;\n}\n\n.rec-text small {\n  font-size: 11px;\n  color: #aaaaaa;\n  line-height: 1.4;\n}\n\n.recommendation-placeholder {\n  padding: 10px;\n  background: rgba(30, 30, 30, 0.4);\n  border-radius: 4px;\n  border: 1px dashed #3a3a3a;\n  text-align: center;\n}\n\n/* Workflow Integration */\n.workflow-integration {\n  border-left-color: #3498db;\n}\n\n.workflow-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.workflow-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #aaaaaa;\n  cursor: pointer;\n}\n\n.workflow-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #3498db;\n}\n\n.workflow-checkbox:hover {\n  color: #ffffff;\n}\n\n/* Help Section */\n.help-section {\n  border-left-color: #95a5a6;\n  padding: 8px;\n}\n\n.help-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px;\n  background: rgba(30, 30, 30, 0.6);\n  border: 1px solid #3a3a3a;\n  border-radius: 4px;\n  color: #aaaaaa;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.help-btn:hover {\n  background: rgba(40, 40, 40, 0.8);\n  color: #ffffff;\n  border-color: #4a4a4a;\n}\n\n/* Modal Styles */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: #2a2a2a;\n  border: 1px solid #4a4a4a;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #3a3a3a;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.modal-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.modal-body label {\n  display: block;\n  color: #cccccc;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.modal-textarea {\n  width: 100%;\n  background: rgba(40, 40, 40, 0.8);\n  border: 1px solid #3a3a3a;\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 13px;\n  font-family: inherit;\n  padding: 12px;\n  resize: vertical;\n  transition: border-color 0.2s ease;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 20px;\n  border-top: 1px solid #3a3a3a;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: #888888;\n  font-size: 28px;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease;\n  line-height: 1;\n}\n\n.close-btn:hover {\n  color: #ffffff;\n}\n\n.cancel-btn,\n.confirm-accept-btn,\n.confirm-reject-btn,\n.confirm-edit-btn {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.cancel-btn {\n  background: rgba(60, 60, 60, 0.8);\n  color: #ffffff;\n  border: 1px solid #4a4a4a;\n}\n\n.confirm-accept-btn {\n  background: #00a855;\n  color: #ffffff;\n}\n\n.confirm-reject-btn {\n  background: #ff4b4b;\n  color: #ffffff;\n}\n\n.confirm-edit-btn {\n  background: #ffa500;\n  color: #ffffff;\n}\n\n.cancel-btn:hover,\n.confirm-accept-btn:hover,\n.confirm-reject-btn:hover,\n.confirm-edit-btn:hover {\n  filter: brightness(1.2);\n}\n\n\n/* Rejection Modal Specific Styles */\n\n.rejection-textarea:focus {\n  outline: none;\n  border-color: #ff6b6b;\n  background: rgba(40, 40, 40, 0.95);\n}\n\n.rejection-textarea::placeholder {\n  color: #666666;\n}\n\n/* Edit Modal Specific Styles */\n\n.edit-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.edit-field label {\n  color: #cccccc;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.birads-select {\n  background: rgba(40, 40, 40, 0.8);\n  border: 1px solid #3a3a3a;\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 13px;\n  font-family: inherit;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.birads-select:focus {\n  outline: none;\n  border-color: #4ecdc4;\n  background: rgba(40, 40, 40, 0.95);\n}\n\n.birads-select option {\n  background: #2a2a2a;\n  color: #ffffff;\n}\n\n.findings-textarea {\n  width: 100%;\n  background: rgba(40, 40, 40, 0.8);\n  border: 1px solid #3a3a3a;\n  border-radius: 6px;\n  color: #ffffff;\n  font-size: 13px;\n  font-family: inherit;\n  padding: 12px;\n  resize: vertical;\n  min-height: 120px;\n  transition: border-color 0.2s ease;\n  line-height: 1.5;\n}\n\n.findings-textarea:focus {\n  outline: none;\n  border-color: #4ecdc4;\n  background: rgba(40, 40, 40, 0.95);\n}\n\n.findings-textarea::placeholder {\n  color: #666666;\n}\n\n/* Explanation Container Styles */\n.explanation-container {\n  padding: 16px;\n  background: rgba(50, 50, 50, 0.8);\n  border: 1px solid #3a3a3a;\n  border-left: 3px solid #9b59b6;\n  border-radius: 6px;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.explanation-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #3a3a3a;\n}\n\n.explanation-header h5 {\n  margin: 0;\n  color: #9b59b6;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.close-explanation-btn {\n  background: none;\n  border: none;\n  color: #888888;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease;\n  line-height: 1;\n}\n\n.close-explanation-btn:hover {\n  color: #ffffff;\n}\n\n.explanation-content {\n  color: #cccccc;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.explanation-content p {\n  margin: 0 0 12px 0;\n}\n\n.explanation-content p:last-child {\n  margin-bottom: 0;\n}\n\n.explanation-note {\n  background: rgba(155, 89, 182, 0.1);\n  border-left: 2px solid #9b59b6;\n  padding: 10px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #bbbbbb;\n}\n\n.explanation-note strong {\n  color: #9b59b6;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
